var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM25.8125 31.5C27.8208 32.5 29.8417 33 31.875 33C32.1917 33 32.4583 32.8917 32.675 32.675C32.8917 32.4583 33 32.1917 33 31.875V28.5C33 28.2333 32.9167 28 32.75 27.8C32.5833 27.6 32.375 27.475 32.125 27.425L29.15 26.775C28.9333 26.725 28.7167 26.7375 28.5 26.8125C28.2833 26.8875 28.0917 27.0167 27.925 27.2L25.55 29.65C24.0833 28.85 22.7708 27.875 21.6125 26.725C20.4542 25.575 19.4083 24.225 18.475 22.675L20.975 20.15C21.1083 20.0167 21.1958 19.8542 21.2375 19.6625C21.2792 19.4708 21.2833 19.2583 21.25 19.025L20.575 15.875C20.525 15.6083 20.4125 15.3958 20.2375 15.2375C20.0625 15.0792 19.8583 15 19.625 15H16.125C15.8083 15 15.5417 15.1083 15.325 15.325C15.1083 15.5417 15 15.8083 15 16.125C15 18.1583 15.5 20.1792 16.5 22.1875C17.5 24.1958 18.8 26 20.4 27.6C22 29.2 23.8042 30.5 25.8125 31.5Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRoundedBlue);
export default __webpack_public_path__ + "static/media/phone-rounded-blue.c6051756a1e05e77a6918a587a56e7f7.svg";
export { ForwardRef as ReactComponent };